import { LOCALE_MAP } from "./const";

interface LocaleConfigItem {
    name: string,
    locale: string,
    localeWithUnderLine: string,
    zendeskLanguage?: string | null,
    linkLocale?: string,
}


export const CodeLangMap = new Map([
    [
        'en-AU',
        {
            "name": "English (Australia)",
            "locale": "en-AU",
            "localeWithUnderLine": "en_US",
            "zendeskLanguage": null,
            "linkLocale": 'en-US',
        }
    ]
]);

export const transformCodeLocaleObj = (locale: string) => {
    if(!CodeLangMap.has(locale)) {
        return;
    }
    const obj = CodeLangMap.get(locale);
    // @ts-ignore
    const transformLocale = LOCALE_MAP.has(obj.linkLocale) ? LOCALE_MAP.get(obj.linkLocale) : obj.linkLocale;
    return {
        ...obj,
        transformLocale,
    };
};

export const transformCodeLocale = (locale: string) => {
    // 如果是硬编码写入的则使用转化后的 - 比如 en-AU -> en
    const codeLocaleObj = transformCodeLocaleObj(locale);
    if(!codeLocaleObj) {
        return locale;
    }
    return codeLocaleObj.transformLocale;
};

export const handleLocaleConfigList = (originList: LocaleConfigItem[]) => {
    const newLocaleConfigList = [...originList];
    CodeLangMap.forEach((newItem) => {
        const insertIndex = newLocaleConfigList.findIndex(item => {
            return item.locale === newItem.linkLocale;
        });
        if (insertIndex > -1) {
            // 插入在链接语言的后面一位
            newLocaleConfigList.splice(insertIndex + 1, 0, newItem);
        } else {
            // 如果没找到就直接放到最后
            newLocaleConfigList.push(newItem);
        }
    });
    return newLocaleConfigList;
}